import { InitiateFromDixaCallback } from 'lib-integrations-partner-widgets';
import { useCallback } from 'react';

import { partnerIntegrationsPairingApi } from 'apis/partnerIntegrations';
import { useAppSelector } from 'utils/redux/useAppSelector';

/**
 * Returns the callback that pre-approves a marketplace app pairing for the
 * organization and resolves with the install URL of the app. It is meant to be
 * provided through the `PairingProvider` so that setup banners can start the
 * pairing.
 *
 * @param integrationType - The type of the integration to pair, e.g. "SHOPIFY".
 */
export const useInitiatePairingFromDixa = (
  integrationType: string,
): InitiateFromDixaCallback => {
  const subdomain = useAppSelector(
    ({ settings }) => settings.organization.organization.subdomain,
  );

  const [initiateFromDixaMutation] =
    partnerIntegrationsPairingApi.useInitiateFromDixaMutation();

  return useCallback(async () => {
    const result = await initiateFromDixaMutation({
      integrationType: integrationType.toLowerCase(),
      subdomain,
    }).unwrap();

    return result?.data?.installUrl;
  }, [integrationType, subdomain, initiateFromDixaMutation]);
};
